import {
  GET_CAMPAIGN_HISTORICAL_SUCCESS,
  GET_CAMPAIGN_HISTORICAL_FAILURE
} from '../constants';

const initState = {
  campaignStats: {}
};

const historicalReducer = (state = initState, action) => {
  switch (action.type) {
    case GET_CAMPAIGN_HISTORICAL_SUCCESS:
      if (
        state.campaignStats[action.data.campaignId] &&
        state.campaignStats[action.data.campaignId].length
      ) {
        return { ...state };
      }
      return {
        ...state,
        campaignStats: {
          ...state.campaignStats,
          [action.data.campaignId]: action.data.stats
        }
      };
    case GET_CAMPAIGN_HISTORICAL_FAILURE:
      return {
        ...state
      };
    default:
      return state;
  }
};

export default historicalReducer;



// WEBPACK FOOTER //
// ./src/store/reducers/historicalReducer.js